export const DEFAULT_CHART_WIDTH = 450;
export const DEFAULT_CHART_HEIGHT = 300;
